<template>
  <div class="job-dashboard f-c">
    <div class="info-board">
      <div class="left">
        <div class="col">
          <div class="stats-info-card blue-business-bg">
            <div class="info-card-left">
              <span class="title">
                {{ jobCounts[UnloadingCountWeek] }} Jobs</span
              >
              <span class="sub-title">{{ UnloadingCountWeek }}</span>
            </div>
          </div>
          <div class="stats-info-card blue-business-bg">
            <div class="info-card-left">
              <span class="title"
                >{{ jobCounts[UnloadingCountMonth] }} Jobs</span
              >
              <span class="sub-title">{{ UnloadingCountMonth }}</span>
            </div>
          </div>
        </div>
        <div class="col">
          <div class="stats-info-card blue-business-bg">
            <div class="info-card-left">
              <span class="title">{{ jobCounts[InboundCountWeek] }} Jobs</span>
              <span class="sub-title"> {{ InboundCountWeek }}</span>
            </div>
          </div>
          <div class="stats-info-card blue-business-bg">
            <div class="info-card-left">
              <span class="title">{{ jobCounts[InboundCountMonth] }} Jobs</span>
              <span class="sub-title">{{ InboundCountMonth }}</span>
            </div>
          </div>
        </div>
      </div>
      <div class="right">
        <div class="title">Shipment Outbound This Week</div>
        <span>to be implemented</span>
      </div>
    </div>
  </div>
</template>
<script>
import {
  InboundJob,
  JobUnassigned,
  JobAssigned,
  JobProcessing,
  JobCompleted,
  OutboundJob,
  UnloadingJob
} from '@/core/models/constant'
import { getMonth, getWeek } from '@/core/utils'
import { queryJobs } from '@/api/job'
const UnloadingCountWeek = 'This Week Unloading '
const UnloadingCountMonth = 'This Month Unloading'
const InboundCountWeek = 'This Week Inbound'
const InboundCountMonth = 'This Month Inbound'
export default {
  name: 'JobDashboard',
  props: {
    jobType: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      InboundJob,
      OutboundJob,
      UnloadingJob,
      UnloadingCountWeek,
      UnloadingCountMonth,
      InboundCountWeek,
      InboundCountMonth,
      jobCounts: {
        [UnloadingCountWeek]: 999,
        [UnloadingCountMonth]: 999,
        [InboundCountWeek]: 999,
        [InboundCountMonth]: 999
      }
    }
  },
  computed: {
    monthTimeRange() {
      return getMonth()
    },
    weekTimeRange() {
      return getWeek()
    },
    jobStatusList() {
      return [JobUnassigned, JobAssigned, JobProcessing, JobCompleted]
    }
  },
  mounted() {
    Object.keys(this.jobCounts).forEach(type => {
      this.countJobs(type)
    })
  },
  methods: {
    countJobs(type) {
      let types, createdTimeRange
      switch (type) {
        case UnloadingCountMonth:
          types = [UnloadingJob]
          createdTimeRange = this.monthTimeRange
          break
        case UnloadingCountWeek:
          types = [UnloadingJob]
          createdTimeRange = this.weekTimeRange
          break
        case InboundCountMonth:
          types = [InboundJob]
          createdTimeRange = this.monthTimeRange
          break
        case InboundCountWeek:
          types = [InboundJob]
          createdTimeRange = this.weekTimeRange
          break
        default:
          break
      }
      queryJobs({
        types,
        createdTimeRange,
        statusList: this.jobStatusList,
        size: 0
      }).then(res => {
        this.jobCounts[type] = res.total
      })
    }
  }
}
</script>
<style scoped lang="scss">
@import '@/assets/styles/common.scss';

.job-dashboard {
  .info-board {
    gap: 10px;

    @extend .f-r;

    .left {
      gap: 10px;

      @extend .f-r;

      .col {
        gap: 10px;

        @extend .f-c;
      }
    }

    .right {
      flex-grow: 1;
      background-color: white;
      border-radius: 8px;
      padding: 20px;

      @extend .shadow-level-three;

      .title {
        font-size: $title-level-two;
        font-family: 'oswald bold', sans-serif;
      }

      .record-row {
        margin-top: 10px;

        @extend .f-r-c-sb;
      }
    }

    .stats-info-card {
      pointer-events: none;
      min-width: 160px !important;

      .info-card-left {
        .title {
          font-size: 30px;
          font-family: 'oswald bold', sans-serif;
        }

        .sub-title {
          margin-top: 5px;
          font-size: 24px;
          font-family: 'oswald light', sans-serif;
        }
      }
    }
  }
}
</style>
